<template>
    <div v-if="hasCustomFields" class="space-y-5">
        <template v-for="field in customFields" :key="field.id">
            <div v-if="shouldShowField(field)">
                <!-- Built-in fields (name, last_name, username) -->
                <template v-if="field.field_options?.field === 'name'">
                    <editable-text-field
                        v-model="field.title"
                        :class="['block text-sm opacity-80 mb-1.5', portalContentAndDesignStore.getPageContentTextColorClass]"
                        for-attribute="name"
                        text-type="label"
                    />
                    <input
                        type="text"
                        name="name"
                        id="name"
                        required
                        v-model="portalContentAndDesignStore.signupFormData.name"
                        :class="portalContentAndDesignStore.getInputStyle"
                    />
                </template>
                <template v-else-if="field.field_options?.field === 'last_name'">
                    <editable-text-field
                        v-model="field.title"
                        :class="['block text-sm opacity-80 mb-1.5', portalContentAndDesignStore.getPageContentTextColorClass]"
                        for-attribute="last_name"
                        text-type="label"
                    />
                    <input
                        type="text"
                        name="last_name"
                        id="last_name"
                        required
                        v-model="portalContentAndDesignStore.signupFormData.last_name"
                        :class="portalContentAndDesignStore.getInputStyle"
                    />
                </template>
                <template v-else-if="field.field_options?.field === 'username'">
                    <editable-text-field
                        v-model="field.title"
                        :class="['block text-sm opacity-80 mb-1.5', portalContentAndDesignStore.getPageContentTextColorClass]"
                        for-attribute="email"
                        text-type="label"
                    />
                    <input
                        type="email"
                        name="email"
                        id="email"
                        required
                        v-model="portalContentAndDesignStore.signupFormData.email"
                        :class="portalContentAndDesignStore.getInputStyle"
                    />
                </template>
            </div>

            <!-- Dynamic custom fields -->
            <div v-else>
                <editable-text-field
                    v-model="field.title"
                    text-type="label"
                    :for-attribute="`cfield_${field.id}`"
                    :class="['block text-sm mb-2 opacity-80', portalContentAndDesignStore.getPageContentTextColorClass]"
                />
                <editable-custom-field
                    :data="field"
                    v-model="portalContentAndDesignStore.signupFormData"
                />
            </div>
        </template>
    </div>

    <!-- Default fields when no custom fields -->
    <div v-else class="mb-5 space-y-5">
        <div>
            <editable-text-field
                v-model="portalContentAndDesignStore.translationSettings.portal_translation_signup_name"
                :class="['block text-sm opacity-80 mb-1.5', portalContentAndDesignStore.getPageContentTextColorClass]"
                for-attribute="name"
                text-type="label"
            />
            <input
                type="text"
                name="name"
                id="name"
                required
                v-model="portalContentAndDesignStore.signupFormData.name"
                :class="portalContentAndDesignStore.getInputStyle"
            />
        </div>
        <div>
            <editable-text-field
                v-model="portalContentAndDesignStore.translationSettings.portal_translation_signup_email"
                :class="['block text-sm opacity-80 mb-1.5', portalContentAndDesignStore.getPageContentTextColorClass]"
                for-attribute="email"
                text-type="label"
            />
            <input
                type="email"
                name="email"
                id="email"
                required
                v-model="portalContentAndDesignStore.signupFormData.email"
                :class="portalContentAndDesignStore.getInputStyle"
            />
        </div>
    </div>
</template>

<script setup>
import {computed} from "vue";
import {usePortalContentAndDesignStore} from "../../../../../../../../stores/partners/portalContentAndDesignStore";
import EditableCustomField from "../../../../../../portal-editable-fields/custom-fields/EditableCustomField.vue";
// editable-text-field is registered globally

const portalContentAndDesignStore = usePortalContentAndDesignStore();

// Get custom fields from store
const customFields = computed(() => {
    return portalContentAndDesignStore.signupPageSettings?.signup_form?.fields || [];
});

// Check if custom fields are available
const hasCustomFields = computed(() => {
    return portalContentAndDesignStore.signupPageSettings?.signup_form?.form_has_fields && customFields.value.length > 0;
});

// Check if a field should be shown
const shouldShowField = (field) => {
    return field.field_options?.portal_signup_form || field.field_options?.portal_signup_popup_form || false;
};
</script>
